<template>
  <div>
    <app-cells>
      <div class="date-picker-wrapper">
        <VueCtkDateTimePicker
          id="date_picker_balance"
          class="custom-date-time-picker custom-date-time-picker--range"
          v-model="filter_dates"
          :custom-shortcuts="custom_shortcuts"
          shortcut="thisYear"
          @is-hidden="onIsHiddenPicker"
          format="YYYY-MM-DD"
          formatted="ll"
          label="Select dates"
          color="#77b017"
          button-color="#77b017"
          overlay
          no-header
          no-label
          locale="en"
          range
          noClearButton
        />
        <div v-if="date_picker_error" class="date-picker-wrapper__error">Choose an end date</div>
      </div>
    </app-cells>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <div class="info-row">
        <div class="info-row__item">
          <div class="info-row__content">
            <span class="info-row__value">{{ snacks_data.amount_paid.toLocaleString() }}$</span>
            <span class="info-row__text">Total paid</span>
          </div>
        </div>
      </div>
      <div class="charts-grid">
        <highcharts :options="graph_options" />
      </div>
    </template>
  </div>
</template>

<script>
import { getSafariAnalyticsSnackBar } from '@/http'
import moment from 'moment'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import { Chart } from 'highcharts-vue'

export default {
  name: 'SafariSnackBarAnalytics',
  components: { highcharts: Chart, VueCtkDateTimePicker },
  data() {
    return {
      is_loaded: false,
      filter_dates: null,
      date_picker_error: false,
      custom_shortcuts: [
        {
          key: 'next30Days',
          label: 'Next 30 days',
          value: () => {
            return {
              start: moment(),
              end: moment().add(30, 'days')
            }
          }
        },
        {
          key: 'next60Days',
          label: 'Next 60 days',
          value: () => {
            return {
              start: moment(),
              end: moment().add(60, 'days')
            }
          }
        },
        {
          key: 'next90Days',
          label: 'Next 90 days',
          value: () => {
            return {
              start: moment(),
              end: moment().add(90, 'days')
            }
          }
        },
        { key: 'last30Days', label: 'Last 30 days', value: 30 },
        { key: 'thisYear', label: 'This year', value: 'year' },
        { key: 'lastYear', label: 'Last year', value: '-year' },
      ],
      graph_options: {
        accessibility: {
          enabled: false,
        },
        CSSObject: {
          fontFamily: 'regular',
          fontSize: '6.2em',
        },
        chart: {
          type: 'spline'
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: [],
        },
        yAxis: {
          title: {
            text: ''
          }
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
            }
          }
        },
        series: []
      },
      snacks_data: {
        amount_paid: null,
      },
    }
  },
  created() {
    setTimeout(() => {
      this.$nextTick(() => {
        this.fetchGraph()
      })
    }, 0)
  },
  methods: {
    onIsHiddenPicker() {
      if (this.filter_dates?.start && this.filter_dates?.end) {
        this.date_picker_error = false
        this.fetchGraph()
      } else this.date_picker_error = true
    },
    fetchGraph() {
      getSafariAnalyticsSnackBar(this.filter_dates.start, this.filter_dates.end)
        .then(response => {
          this.snacks_data = {
            amount_paid: response.data.amount_paid,
          }
          this.graph_options.xAxis.categories = response.data.graph.categories
          this.graph_options.series = response.data.graph.series
          this.is_loaded = true
        })
    },
  }
}
</script>
